import { AdBanner } from '@techminds/ad-banner';
import classNames from 'classnames/bind';
import { useCallback, useState } from 'react';
import styles from './index.module.scss';

const { useInView } = require('react-intersection-observer');
const scrollAmount = 360;
const cx = classNames.bind(styles);
const ads = [
  {
    adUnitId: 'tm_travel_flight_main_text_banner_0',
    uct: 'KR',
  },
  {
    adUnitId: 'tm_travel_flight_main_text_banner_1',
    uct: 'KR',
  },
  {
    adUnitId: 'tm_travel_flight_main_text_banner_2',
    uct: 'KR',
  },
  {
    adUnitId: 'tm_travel_flight_main_text_banner_3',
    uct: 'KR',
  },
  {
    adUnitId: 'tm_travel_flight_main_text_banner_4',
    uct: 'KR',
  },
];

const TextBanner = () => {
  const [textBannerLoadedList, setTextBannerLoadedList] = useState<boolean[]>(
    new Array(ads.length).fill(false),
  );
  const isVisible = textBannerLoadedList.some(loaded => loaded);
  const { ref: firstRef, inView: firstInView } = useInView({ threshold: 0.9 });
  const { ref: lastRef, inView: lastInView } = useInView({ threshold: 0.9 });

  const handleButtonClick = useCallback((type: 'prev' | 'next') => {
    if (typeof window !== 'undefined') {
      const container = window.document.querySelector('#TextBannerList');
      container?.scroll({
        left: type === 'prev' ? -1 * scrollAmount : scrollAmount,
      });
    }
  }, []);

  if (ads?.length < 1) {
    return null;
  }

  return (
    <div id="TextBanner" className={cx('TextBanner', !isVisible && 'hidden')}>
      <div className={cx('inner')}>
        <div
          id="TextBannerList"
          className={cx('list')}
          key={textBannerLoadedList.join(',')}
        >
          {ads.map((adSlotInfo, index) => {
            const handleAdLoaded = () => {
              setTextBannerLoadedList(prev => {
                const copiedPrevLoadedList = [...prev];
                copiedPrevLoadedList[index] = true;
                return copiedPrevLoadedList;
              });
            };

            return (
              <div
                className={cx(
                  'banners',
                  !textBannerLoadedList[index] && 'hidden',
                )}
                key={adSlotInfo.adUnitId + index}
                ref={
                  textBannerLoadedList[index] && index === 0
                    ? firstRef
                    : textBannerLoadedList[index]
                      ? lastRef
                      : undefined
                }
              >
                <AdBanner adSlotInfo={adSlotInfo} onAdLoaded={handleAdLoaded} />
              </div>
            );
          })}
        </div>
        <button
          type="button"
          className={cx('prev', firstInView && 'hidden')}
          aria-label="이전"
          onClick={() => handleButtonClick('prev')}
        />
        <button
          type="button"
          className={cx('next', lastInView && 'hidden')}
          aria-label="다음"
          onClick={() => handleButtonClick('next')}
        />
      </div>
    </div>
  );
};

export default TextBanner;
